import React, { useLayoutEffect } from "react";
import _ from "lodash";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5locales_it_IT from "@amcharts/amcharts5/locales/it_IT"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { addSeriesBullet } from "@components/Charts/commons";
import {addLicense} from "../../../components/Charts/commons";

function TrendChart({
  id,
  data,
  serieNamesAndColors,
  minWidth = "800px",
  minHeight = "400px",
}) {
  useLayoutEffect(() => {
    addLicense();
    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    var root = am5.Root.new(id);
    root.locale = am5locales_it_IT;

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);
    root.numberFormatter.set("numberFormat", "#.0a")
    root.dateFormatter.set("dateFormat", "MMM-yyyy")

    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    var chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        pinchZoomX: true,
        paddingLeft: 0,
        layout: root.gridLayout
      })
    );

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    var cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        behavior: "none",
      })
    );
    cursor.lineY.set("visible", false);

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var xAxis = chart.xAxes.push(
      // am5xy.CategoryAxis.new(root, {
      //   categoryField: "month",
      //   startLocation: 0.5,
      //   endLocation: 0.5,
      //   renderer: am5xy.AxisRendererX.new(root, {
      //     minorGridEnabled: true,
      //     minGridDistance: 70,
      //   }),
      //   tooltip: am5.Tooltip.new(root, {}),
      // })
      am5xy.DateAxis.new(root, {
        baseInterval: {timeUnit: 'month', count: 1},
        gridIntervals: [{timeUnit: "month", count: 1}],
        renderer: am5xy.AxisRendererX.new(root, {}),
      })
    );

    xAxis.data.setAll(data);

    var yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {
          pan: "zoom",
        }),
      })
    );


    yAxis.get("renderer").labels.template.adapters.add("text", function (text, target) {
      return text + "€";
    });

    let legend = chart.bottomAxesContainer.children.push(
      am5.Legend.new(root, {
        // centerY: am5.p50,
        // y: am5.percent(50),
        layout: am5.GridLayout.new(root, {
          maxColumns: 3,
          fixedWidthGrid: false
        })
      })
    );

    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/

    function createSeries(name, field, color) {
      var series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: name,
          xAxis: xAxis,
          yAxis: yAxis,
          stacked: true,
          valueYField: field,
          valueXField: "month",
          // categoryXField: "month",
          tooltip: am5.Tooltip.new(root, {
            pointerOrientation: "horizontal",
            labelText: "[bold]{name}[/]: {valueY}€",
          }),
          fill: am5.color(color)
        })
      );

      series.fills.template.setAll({
        fillOpacity: 1,
        visible: true,
      });
      series.data.processor = am5.DataProcessor.new(root, {
        dateFields: ['month'],
        dateFormat: "yyyy-MM-dd"
      })
      series.data.setAll(data);
      series.appear(1000);
      // Add bullet
      addSeriesBullet(root, series, 3, 0);
      legend.data.push(series);
    }

    serieNamesAndColors.forEach((s) => {
      if (s.name === "month") return;
      createSeries(s.name, s.name, s.color);
    });

    // Add scrollbar
    // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
    chart.set(
      "scrollbarX",
      am5.Scrollbar.new(root, {
        orientation: "horizontal",
      })
    );

    chart.appear(1000, 100);
    return () => {
      root.dispose();
    };
  }, [data, id]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div id={id} style={{ minWidth: minWidth, minHeight: minHeight }} />;
}

export default React.memo(TrendChart, (props, nextProps) => {
  return _.isEqual(props.data, nextProps.data);
});
